<script setup lang="ts">
import { createReusableTemplate } from '@vueuse/core'
import { type SearchParams } from '../types'

defineProps<{
  searchParams: SearchParams
}>()

const [DefineTemplate, ReuseTemplate] = createReusableTemplate<{ label: string; value: string }>()
</script>

<template>
  <DefineTemplate v-slot="{ label, value }">
    <div class="flex items-center justify-between border-b py-1">
      <dt class="text-gray-500">{{ label }}:</dt>
      <dd class="text-gray-700">{{ value }}</dd>
    </div>
  </DefineTemplate>

  <div class="rounded-lg border bg-gray-50 p-3 text-sm">
    <p class="mb-2 text-xs font-semibold uppercase text-gray-600">Search Parameters:</p>
    <dl>
      <ReuseTemplate label="Name" :value="searchParams?.name" />
      <ReuseTemplate label="Date of Birth" :value="searchParams?.date_of_birth" />
      <ReuseTemplate label="Country" :value="searchParams?.country" />
      <ReuseTemplate label="Entity Type" :value="searchParams?.entity_type" />
    </dl>
  </div>
</template>

<style scoped>
dl div:last-child {
  @apply border-b-0;
}
</style>
